import React from 'react';
import TableHeaderCell from 'components/common/ClinicManager/TableHeaderCell';
import { IHeaderProperty } from '../utils';

export interface ITableHeader {
  sortProp: Nullable<string>;
  sortOrder: Nullable<string>;
  sortBy: (prop: string) => void;
  headerKey: string;
  headerValue: IHeaderProperty;
}

const PatientAdherenceHeaderCell = (props: ITableHeader) => {
  const { headerKey, headerValue, ...rest } = props;
  const sortableHeader = ['first_name', 'last_name', 'email', 'external_ref'];
  const passingProps = sortableHeader.includes(headerKey) ? rest : {};

  return (
    <TableHeaderCell
      {...passingProps}
      propName={headerKey}
      theme="dark"
      style={{ minWidth: headerValue.minWidth, whiteSpace: 'nowrap' }}
      isFromStickyTable
    >
      <span>{headerValue.label}</span>
    </TableHeaderCell>
  );
};

export default PatientAdherenceHeaderCell;
